import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";

interface LeagueCodeModalProps {
  onClose: Function;
  shouldShow: boolean;
  rodeoEventId: string;
  performanceId: string;
}

interface LeagueCodeModalValues {
  league_code: string;
}

const LeagueCodeModalSchema = yup.object().shape({
  league_code: yup.string().required("League code is required"),
});

export default function LeagueCodeModal({ onClose, shouldShow, rodeoEventId, performanceId }: LeagueCodeModalProps) {
  const { control, errors, setValue, handleSubmit } = useForm<LeagueCodeModalValues>({
    resolver: yupResolver(LeagueCodeModalSchema),
    defaultValues: {
      league_code: "",
    },
  });

  const eventApi = useEventApi();
  const userAction = useAppUserAction();
  const toast = useToaster();

  const onSubmit = (values: LeagueCodeModalValues) => {
    console.log({ values });
    let params = {
      rodeo_event_id: rodeoEventId,
      performance_id: performanceId,
      league_code: values?.league_code,
    };
    eventApi.callSaveLeagueCode(
      params,
      (message: any, resp: any) => {
        // userAction.LeagueCode(resp.league_code);
        onClose(resp);
        // console.log({resp})
      },
      (message: any) => {
        toast.error(message);
      }
    );
  };

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">League Code</h2>
          <button type="button" className="btn-close" onClick={() => onClose()}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">Enter Your League Code</h4>
            <div className="mb-3">
              {/* <label className="form-label">Display Name</label> */}
              <Controller
                control={control}
                name="league_code"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormTextInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.league_code}
                    placeholder="League Code"
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={handleSubmit(onSubmit)}>
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
